import { affinityToStem } from './affinity-to-stem';

// Horace Mann: KY business quoted under a General Agency code (stem HO0017) must be
// written under a KY field agent's code (stem HO0019) so that agent can see it. See #34207.
export const STATE_FORCED_AFFINITY_STEM: Record<string, Record<string, string>> = {
  KY: { HO0017: 'HO0019' }
};

export function getStateForcedAffinityStem({
  state,
  affinity
}: {
  state?: string | null;
  affinity?: string | null;
}): string | null {
  if (!state || !affinity) {
    return null;
  }
  const stem = affinityToStem(affinity.trim().toUpperCase());
  return STATE_FORCED_AFFINITY_STEM[state]?.[stem] ?? null;
}
